import React, { memo } from 'react';
import './Container.css';

const Container = memo(({ 
  children, 
  variant = 'default', 
  size = 'default',
  className = '',
  fullHeight = false,
  centered = false,
  ...props 
}) => {
  const classes = [
    'container',
    `container--${variant}`,
    `container--${size}`,
    fullHeight && 'container--full-height',
    centered && 'container--centered',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
});

Container.displayName = 'Container';

export default Container;